<template>
    <fieldset :id="controlId">
        <legend class="lni-c-input-list__legend">{{ labelText }}</legend>
        <div>
        <x-input-currency
            ref="rate"
            class="lni-u-mt0"
            :data-control-id="controlId + '_rate'"
            :data-parent-id="controlId"
            :data-parent-short-name="shortName"
            :is-nested="true"
            data-short-name="Rate"
            customWidth="true"
            data-label-text="Rate"
            :hideLabel="true"
            maxlength="6"
            v-on:dataChanged="onDataChanged"
            v-on:errorChanged="onRateErrorChanged"
        >
            <x-error v-if="errorText('rate')" :data-local-text="errorText('rate')" />
        </x-input-currency>
        <x-select
            ref="payTimePeriod"
            class="lni-u-mt0"
            :data-control-id="controlId + '_payTimePeriod'"
            :data-parent-id="controlId"
            :data-parent-short-name="shortName"
            :is-nested="true"
            data-short-name = "Pay Time Period"
            :data-options="options"
            data-label-text="per"
            inline="true"
            customWidth="true"
            maxlength="9"
            data-placeholder="Select..." 
            v-on:dataChanged="onDataChanged"
            v-on:errorChanged="onPayTimePeriodErrorChanged"
        >
            <x-error v-if="errorText('payTimePeriod')" :data-local-text="errorText('payTimePeriod')" />
        </x-select>
    </div>
    </fieldset>
</template>

<script>
import framework from '../../framework';
/**
*  The x-payrate component.
*  @module components/x-payrate
*/


/**
* The x-payrate is a complex control for pay rate.
*/
export default {
    name: 'x-payrate',
    mixins: [
        framework.mixins.abstractAggregateInput,
    ],
    mounted() {
        this.initialize();
    },
    computed: {
        componentValue: {
            get() {
                return {
                    rate: this.$refs.rate.value,
                    payTimePeriod: this.$refs.payTimePeriod.value,
                };
            },
            set(newValue) {
                this.$refs.rate.value = newValue.rate;
                this.$refs.payTimePeriod.value = newValue.payTimePeriod;
            },
        },
        /**
        * The text for the label.
        * @returns {string} label text.
        */
        labelText() {
            return this.getAttribute('labelText', '');
        },
        /**
         * The list of radio button options
         * @returns {*} array of options.
         */
        options() {
            return this.getOptions();
        },
    },
    methods: {
        /**
         * Adds the error from the child component to the errors of this component
         * @param {*} errorMessage The error message that the child component is passing.
         * @returns {void}
         */
        onRateErrorChanged(errorMessage) {
            this.onErrorChanged('rate', errorMessage);
        },
        /**
         * Adds the error from the child component to the errors of this component
         * @param {*} errorMessage The error message that the child component is passing.
         * @returns {void}
         */
        onPayTimePeriodErrorChanged(errorMessage) {
            this.onErrorChanged('payTimePeriod', errorMessage);
        },
    },
};

</script>



// WEBPACK FOOTER //
// source/components/x-payrate/x-payrate.vue